import { render, staticRenderFns } from "./VuesticPageNotFoundSearch.vue?vue&type=template&id=487dbc66"
import script from "./VuesticPageNotFoundSearch.vue?vue&type=script&lang=js"
export * from "./VuesticPageNotFoundSearch.vue?vue&type=script&lang=js"
import style0 from "./VuesticPageNotFoundSearch.vue?vue&type=style&index=0&id=487dbc66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports